import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";

import Banner from "../../assets/homeImage/banner.png";

import GradientTextWithStroke from "./index";
import React from "react";

const Privacy = () => {
  const data = [
    {
      category: "Data You Provide Directly (Account Creation & Use)",
      rows: [
        {
          dataPoint:
            "Mobile Number: Mandatory for user verification via One-Time Password (OTP).",
          purpose: "Account security, authentication, and fraud prevention.",
        },
        {
          dataPoint:
            "Geographic Region (State): Mandatory confirmation of your access region.",
          purpose:
            "Offering region-specific vernacular content and localized support services.",
        },
        {
          dataPoint:
            "Language Choice: Mandatory confirmation of your preferred language.",
          purpose: "Customizing the Digital Venue's accessible language.",
        },
        {
          dataPoint:
            "Documentation: May be mandatory for utilizing full Offerings.",
          purpose:
            "Compliance with applicable laws via licensed service providers (we store only an encrypted hash, not the documents themselves).",
        },
        {
          dataPoint:
            "Contact List (Phonebook): Optional access to contacts and call logs.",
          purpose:
            "Enhancing referral features and simplifying user verification via missed call for streamlined sign-up.",
        },
        {
          dataPoint:
            "Profile Data: Optional full name, email, gender, date of birth, city, display picture.",
          purpose:
            "Maintaining your user profile and offering personalized services.",
        },
        {
          dataPoint:
            "Feedback/Interests: Optional information on preferences, interests, or feedback.",
          purpose: "Improving Offerings and providing curated experiences.",
        },
      ],
    },
    {
      category: "Data Collected from Service Usage",
      rows: [
        {
          dataPoint:
            "Location Information: Optional real-time location data (including background collection, if permitted).",
          purpose:
            "Curating localized content, providing region-specific support, and enforcing legal content viewership restrictions.",
        },
        {
          dataPoint:
            "Transaction Details: Data on amounts transacted, purchase history, payment mode, date, time, and invoices.",
          purpose:
            "Processing transactions, billing, audit compliance, and purchase history management.",
        },
        {
          dataPoint:
            "Device Information: Hardware model, IP address, installed software, unique device identifiers, advertising identifiers, network data.",
          purpose:
            "Identifying users, preventing fraud, maintaining platform security, and optimizing device performance.",
        },
        {
          dataPoint:
            "Usage Data: Access dates/times, pages viewed, system activity (crashes), browser type, third-party interaction sources.",
          purpose:
            "Analyzing user interaction patterns to diagnose issues and continually improve the user experience (UI/UX).",
        },
        {
          dataPoint:
            "Audio Interaction Data: Audio streams, transcripts (text representation), logs, and metadata (UIDs, timestamps) with explicit consent.",
          purpose:
            "Enabling optional audio features like audio bios or real-time communication with other users.",
        },
        {
          dataPoint: "Cookies: Small data files stored on your device.",
          purpose:
            "Recognizing you and your device, understanding navigation patterns, and enhancing overall user experience. You can disable cookies via browser settings.",
        },
      ],
    },
    {
      category: "Data from Other Sources",
      rows: [
        {
          dataPoint:
            "Third-Party Logins: Data received when you log in or connect using social media or other third-party plug-ins.",
          purpose:
            "Streamlining account access and maintaining user connectivity. You are bound by the third party's privacy policies.",
        },
      ],
    },
  ];

  const tableData = [
    {
      reason: "Service Delivery",
      descriptions: [
        // ✅ must be an array
        "Maintaining and Personalizing Offerings: Using data to create your profile, improve platform design, facilitate transactions (purchases, billing), confirm eligibility for promotions, and improve your experience with tailored recommendations and offers.",
        "Internal Operations and Security: Conducting data analysis, troubleshooting bugs, detecting and preventing fraud, and ensuring the security and integrity of the Digital Venue.",
      ],
    },
    {
      reason: "User Support",
      descriptions: [
        "Providing timely customer support and resolving concerns or issues arising from your use of our Offerings.",
      ],
    },
    {
      reason: "Innovation & Development",
      descriptions: [
        "Conducting research and analysis to develop the Digital Venue's features, improve the UI/UX, and develop new content, tools, or functionalities that better serve user needs.",
      ],
    },
    {
      reason: "Outreach and Marketing",
      descriptions: [
        "Promoting and marketing the Digital Venue and our Offerings. We may send personalized communications and notifications relevant to your activity with your consent.",
      ],
    },
    {
      reason: "Regulatory Compliance",
      descriptions: [
        "Meeting our legal and contractual obligations, cooperating with legal, regulatory, or investigatory authorities, and protecting users, us, or third parties from harm or fraud.",
      ],
    },
  ];

  const tableData1 = [
    {
      sharedWith: "Service Partners",
      purposes: [
        "Third-Party Service Providers: Sharing only necessary data with partners who provide core services like infrastructure, maintenance, analytics,  and marketing on our behalf.",
      ],
    },
    {
      sharedWith: "External Platforms",
      purposes: [
        "Third-Party Services: If you connect to external websites, products, or services through our Digital Venue, the use of those services is subject to their own privacy policies. We are not responsible for their practices.",
      ],
    },
    {
      sharedWith: "Corporate Entities",
      purposes: [
        "Affiliates & Subsidiaries: Sharing data with related entities to fulfill contractual obligations or enhance services.",
      ],
    },
    {
      sharedWith: "Legal/Business Changes",
      purposes: [
        "Change in Control: Disclosure of databases in the event of a merger, acquisition, or sale of all or substantially all of our assets or equity.",
      ],
    },
    {
      sharedWith: "Law Enforcement",
      purposes: [
        "Authorities & Courts: Sharing data as required by applicable law, court order, or to cooperate with law enforcement, especially to protect against fraud or ensure physical safety.",
      ],
    },
  ];

  const tableData2 = [
    {
      right: "Access",
      scopes: [
        "You can view and access much of your personal information directly through your account or profile on the Digital Venue.",
      ],
    },
    {
      right: "Correction",
      scopes: [
        "You may request that we correct, update, or rectify inaccuracies in your personal information. We will make reasonable efforts to comply promptly.",
      ],
    },
    {
      right: "Withdrawal of Consent",
      scopes: [
        "You may withdraw your consent for us to process your personal information. If you withdraw consent, we may be unable to provide the Offerings that rely on that data. To withdraw consent, please contact us via the email address provided below.",
      ],
    },
    {
      right: "Account Deletion",
      scopes: [
        "You may request the deletion of your account via your profile menu on the Winnsta Digital Venue or by contacting us. If requested, we will typically deactivate your account for 90 days. If you do not reactivate it during this period, your user account will be permanently deleted.",
      ],
    },
  ];

  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        px={{ base: 4, md: 20 }}
        py={{ base: 8, md: 12 }}
        color="white"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "right" }}
            ml={{ base: 0, md: "50%" }} // <- sets content to start at 50% width on md screens
          >
            <GradientTextWithStroke
              text="Account Deletion"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mr="280px"
            >
              {/* Winnsta - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Section 3: Text */}
      <Box maxW="100%" py={6} px={4}>
        <Text textAlign="center" fontSize="35px" color="white" mb={6}>
          Winnsta Gaming - Account Deletion
        </Text>

        <Flex width="100%" justifyContent="center" alignItems="center">
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize={"24px"} fontWeight={"bold"} color="white">
              Your Data Rights
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We are committed to empowering you with control over your personal
              information, as mandated by applicable law:
            </Text>
          </Flex>
        </Flex>
        <Box bg="#3A005E" py={10} display="flex" justifyContent="center">
          <TableContainer
            width={{ base: "95%", md: "1200px" }}
            border="1px solid #7A3DAF"
            borderRadius="lg"
            boxShadow="0 0 12px rgba(255,255,255,0.1)"
            bg="#4B007F"
            p={{ base: 2, md: 4 }}
            overflowX={{ base: "auto", md: "hidden" }}
          >
            <Table size="sm" variant="simple">
              <Thead bg="#6200A8">
                <Tr>
                  <Th color="white" fontSize="md" borderColor="whiteAlpha.300">
                    Right
                  </Th>
                  <Th color="white" fontSize="md" borderColor="whiteAlpha.300">
                    Scope and How to Exercise
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {tableData2.map((row, i) => (
                  <React.Fragment key={i}>
                    {row.scopes.map((scope, j) => (
                      <Tr key={j}>
                        {j === 0 && (
                          <Td
                            rowSpan={row.scopes.length}
                            color="#EEDCFF"
                            borderColor="#7A3DAF"
                            whiteSpace="normal"
                            fontSize={{ base: "xs", md: "sm" }}
                            w={{ base: "100%", md: "30%" }}
                          >
                            {row.right}
                          </Td>
                        )}
                        <Td
                          color="#EEDCFF"
                          borderColor="#7A3DAF"
                          whiteSpace="normal"
                          fontSize={{ base: "xs", md: "sm" }}
                          w={{ base: "100%", md: "30%" }}
                        >
                          {scope}
                        </Td>
                      </Tr>
                    ))}
                  </React.Fragment>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>

        <Flex width="100%" justifyContent="center" alignItems="center">
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              <b>Important Note:</b> These rights are subject to legal
              limitations. For instance, we cannot delete transaction records we
              are legally obliged to maintain. We will also retain personal
              information necessary for legal claims, fraud investigation,
              system security, or internal purposes.
            </Text>
            {/* <Text textAlign="center" fontSize="20px" color="#A1A1A1" p="30px" width="100%">Contact at: ninjapurplework@gmail.com</Text> */}
            <Box
              as="div"
              textAlign="center"
              fontSize="20px"
              color="#A1A1A1"
              p="30px"
              width="100%"
              fontWeight="bold"
            >
              Contact at:{" "}
              <a
                href="mailto:ninjapurplework@gmail.com"
                style={{
                  color: "#A1A1A1",
                  textDecoration: "underline",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                ninjapurplework@gmail.com
              </a>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Privacy;
